<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">


        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/5 md:mb-0">
            <ValidationProvider vid="is_product_irradiation" name="is_product_irradiation" rules="" v-slot="{ errors }">
              <small class="label">Irradiation ?</small>
              <vs-switch v-model="form.is_product_irradiation" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-4/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_product_irradiation" vid="is_product_irradiation_comment" name="is_product_irradiation_comment" rules="required" v-slot="{ errors }">
              <small class="label">If yes, Comment</small>
              <vs-input type="text" name="is_product_irradiation_comment" class="w-full" v-model="form.is_product_irradiation_comment" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/5 md:mb-0">
            <ValidationProvider vid="is_chemical_modification" name="is_chemical_modification" rules="" v-slot="{ errors }">
              <small class="label">Chemical Modification ?</small>
              <vs-switch v-model="form.is_chemical_modification" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-4/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_chemical_modification" vid="is_chemical_modification_detail" name="is_chemical_modification_detail" rules="required" v-slot="{ errors }">
              <small class="label"> If yes, please provide details</small>
              <vs-input type="text" name="is_chemical_modification_detail" class="w-full" v-model="form.is_chemical_modification_detail" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>


        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-if="!isCompleted" @click.stop="onClickMarkAsComplete" class="ml-4 mt-2" type="border" color="warning">Mark As Complete</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import RawMaterialForm from "@/mixins/RawMaterialForm";

    export default {
        name: "SupplierManufacturingHome",
      data() {
          return {
            form: {
              is_product_irradiation: false,
              is_chemical_modification: false
            },
            id: null,
            status: {},
          }
      },
      props : {
        isCompleted: { default: false },
      },
      mixins: [SuccessMessage, ErrorMessages, RawMaterialForm],
      methods: {
        onClickNext() {
          this.$emit('notify', 1)
        },
        async onClickMarkAsComplete() {
          this.$emit('mark-as-complete', 'is_raw_material_product_treatment_marked_completed')
        },
        onClickSubmit() {
          this.status.is_raw_material_product_treatment_complete ? this.$mixinsOpenUpdateConfirm() : this.onClickCreate()
        },

        async onClickUpdate() {
          this.$vs.loading()
          try {
            const data= (await SupplierRawMaterialRepository.UpdateRawMaterialProductTreatments(this.id, this.form))
            this.showSuccessMessage('Raw Material Product Treatment Details Updated!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },
        async onClickCreate() {
          this.$vs.loading()
          try {
            const data= (await SupplierRawMaterialRepository.CreateRawMaterialProductTreatments(this.form))
            this.showSuccessMessage('Raw Material Product Treatment Details Created!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },

        async loadData() {
          this.$vs.loading()
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialProductTreatments(this.id)).data
          this.form =data
          this.$vs.loading.close()
        },
        async loadStatus() {
          this.$vs.loading()
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
          this.status =data
          this.$vs.loading.close()
        },
      },
      async mounted() {
        this.id = this.$route.params.id
        this.form.supplier_raw_material_id =  this.id
        await this.loadStatus()
        if (this.status.is_raw_material_product_treatment_complete) {
          await this.loadData()
        }
      }
    }
</script>

<style scoped>

</style>
